import React from 'react';
interface FooterProps {
  onOpenModal: (modalId: 'privacy' | 'terms' | 'disclaimer') => void;
}
export function Footer({
  onOpenModal
}: FooterProps) {
  return <footer className="bg-[#2A1F17] text-[rgba(250,247,242,0.6)] py-10 px-5 text-center font-sans text-[13px]" data-id="element-60">
      <div className="font-serif text-xl text-[#FAF7F2] mb-2" data-id="element-61">B.A.B.Y. 365</div>
      <div className="mb-6 italic" data-id="element-62">
        From survival instinct to elite cognitive development design
      </div>

      <div className="flex justify-center items-center gap-4 flex-wrap mb-5" data-id="element-63">
        <button onClick={() => onOpenModal('privacy')} className="text-[rgba(250,247,242,0.6)] bg-transparent text-[13px] font-sans transition-colors hover:text-[#FAF7F2] underline underline-offset-2" data-id="element-64">
          Privacy Policy
        </button>
        <span className="text-[rgba(250,247,242,0.2)]" data-id="element-65">|</span>
        <button onClick={() => onOpenModal('terms')} className="text-[rgba(250,247,242,0.6)] bg-transparent text-[13px] font-sans transition-colors hover:text-[#FAF7F2] underline underline-offset-2" data-id="element-66">
          Terms of Service
        </button>
        <span className="text-[rgba(250,247,242,0.2)]" data-id="element-67">|</span>
        <button onClick={() => onOpenModal('disclaimer')} className="text-[rgba(250,247,242,0.6)] bg-transparent text-[13px] font-sans transition-colors hover:text-[#FAF7F2] underline underline-offset-2" data-id="element-68">
          Disclaimer
        </button>
      </div>

      <div className="text-xs text-[rgba(250,247,242,0.4)] mb-5" data-id="element-69">
        © 2026 B.A.B.Y. 365. All rights reserved.
      </div>

      <div className="max-w-[700px] mx-auto text-[11px] text-[rgba(250,247,242,0.3)] leading-relaxed" data-id="element-70">
        This site is not a part of the Facebook™ website or Meta Platforms Inc.
        Additionally, this site is NOT endorsed by Facebook™ in any way.
        FACEBOOK™ is a trademark of META PLATFORMS, INC. The results mentioned
        are not typical. Individual results will vary based on the effort,
        experience, and situation of each family. This content is solely for
        educational and informational purposes. Always consult your pediatrician
        for medical decisions.
      </div>
    </footer>;
}